import React from "react";
import { Col, Row } from "antd";
import { t } from "i18next";

import style from "./InformationAbout.module.scss";
import { IDrustvoInfoProps } from "../../../../modules/ministry/ministry.types";
import { IUserInformationDozvolaProps } from "../../../../modules/obligee/exciseLicences/exciseLicences.types";

interface IInformationAboutProps {
  type: string;
  data?: IDrustvoInfoProps;
  dataLicence?: IUserInformationDozvolaProps;
}

export const InformationAbout: React.FC<IInformationAboutProps> = ({
  type,
  data,
  dataLicence,
}) => {
  return (
    <Col className={style.mainContainer} span={24}>
      <Col className={style.title} span={24}>
        {t("AKCIZNE_MARKICE.INFORMACIJE_O")} {type}
      </Col>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={12} className="pb-10">
              <span className={style.fontSize}>
                {t("AKCIZNE_MARKICE.NAZIV_OBVEZNIKA")}:
              </span>
            </Col>
            <Col span={12}>
              <span className={style.fontSize}>
                {data ? data.nazivObveznika : dataLicence?.naziv}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <span className={style.fontSize}>
                {t("AKCIZNE_MARKICE.MESTO_SEDISTA")}:
              </span>
            </Col>
            <Col span={12}>
              <span className={style.fontSize}>
                {data ? data.mestoSedista : dataLicence?.imeGrada}
              </span>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={12} className="pb-10">
              <span className={style.fontSize}>
                {t("AKCIZNE_MARKICE.PRETEZNA_DELATNOST")}:
              </span>
            </Col>
            <Col span={12}>
              <span className={style.fontSize}>
                {data ? data.preteznaDelatnost : dataLicence?.preteznaDelatnost}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <span className={style.fontSize}>
                {t("AKCIZNE_MARKICE.PIB")}:
              </span>
            </Col>
            <Col span={12}>
              <span className={style.fontSize}>
                {data ? data.pib : dataLicence?.pib}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};
